export default __webpack_public_path__ + "static/media/React-Native.8a71f1a9.jpg";